import { render, staticRenderFns } from "./PromisesDeliveryResult.vue?vue&type=template&id=5ecc85d8"
import script from "./PromisesDeliveryResult.vue?vue&type=script&lang=js"
export * from "./PromisesDeliveryResult.vue?vue&type=script&lang=js"
import style0 from "./PromisesDeliveryResult.vue?vue&type=style&index=0&id=5ecc85d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports